import { Dispatch } from "react";
import { setErrorMesssage } from "../store/actions/application.actions";
import { createRequestOptions } from "./utils";

export class ApiHelper {
    /**
     * Handles the error by console logging it and then dispatching it to the redux state error.
     * @param errorDetail The detail to add to any console logging error message.
     * @param dispatch The dispatch object to use to dispatch any error messages to redux.
     * @param userErrorMessage The message to display to the user of the API call fails.
     */
    public static handleError(errorDetail: string, dispatch: Dispatch<any>, userErrorMessage: string): void {
        console.log(`${userErrorMessage}. Error detail: ${errorDetail}`);
        dispatch(setErrorMesssage(userErrorMessage));
    }

    /**
     * Helper method for calling an API that returns JSON and calling a callback function with the resulting JSON.
     * @param apiUrl The URL of the API to call.
     * @param httpMethod The http method type e.g. Get, Put etc.
     * @param callback The callback method to call with any resulting JSON.
     * @param dispatch The dispatch object to use to dispatch any error messages to redux.
     * @param userErrorMessage The message to display to the user of the API call fails.
     * @param body Any body to post to the API.
     */
    public static getApiResponse(apiUrl: string, httpMethod: string, callback: (jsonResponse: any) => void, dispatch: Dispatch<any>, userErrorMessage: string = "An error occured logging in.", body: string = ""): void {
        fetch(apiUrl, createRequestOptions(httpMethod, body))
            .then((response) => {
                if (response.ok) {
                    response.json()
                        .then(value => {
                            callback(value);
                        });
                }
                else {
                    const error: string = `Error calling API: ${apiUrl}. Response.status: ${response.statusText} (${response.status}).`;
                    ApiHelper.handleError(error, dispatch, userErrorMessage);
                }
            })
            .catch((reason) => {
                const error: string = `Error calling API: ${apiUrl}. Reason: ${reason}.`;
                ApiHelper.handleError(error, dispatch, userErrorMessage);
            });
    }
}